// Copyright (c) 2020 Deere & Company

import {
    exportSpaClaims,
    readSpaClaims
} from './get-spa-claims';

import {
    onSearch,
    updateSearchByDropDown,
    updateSearchQueryString
} from './search';
import {
    readTabmSettings,
    resetTcsmSettingsFacet,
    toggleSpaLevelsListItems,
    updateSelectedSpaLevelsList
} from './tcsm-settings';
import {
    resetWipFacets,
    updateWipFacets
} from './wip-facets';
import {
    updateSpaClaimsListFilterBy,
    updateSpaClaimsListSortBy,
    updateSpaClaimsListSortDirection
} from './spa-claims-search-filters';
import {readTerritories} from './get-territories';
import {toggleReportsAccordion} from '../../shared/action-creators/reports-accordion';
import {updateFacetFilterText} from './facet-filter-text';
import {updateFilteredTerritories} from './filtered-territories';

export default {
    exportSpaClaims,
    onSearch,
    readSpaClaims,
    readTabmSettings,
    readTerritories,
    resetTcsmSettingsFacet,
    resetWipFacets,
    toggleReportsAccordion,
    toggleSpaLevelsListItems,
    updateFacetFilterText,
    updateFilteredTerritories,
    updateSearchByDropDown,
    updateSearchQueryString,
    updateSelectedSpaLevelsList,
    updateSpaClaimsListFilterBy,
    updateSpaClaimsListSortBy,
    updateSpaClaimsListSortDirection,
    updateWipFacets
};



// WEBPACK FOOTER //
// ./src/tabm/wip/action-creators/index.js